import { useMediaQuery } from '@mui/system';
import { DatePicker, LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { DOB_DATE_FORMAT } from 'utils/lib/utils/date';
import { StyledQuestionnaireItem } from '../hooks/useStyleItems';

type DateInputProps = {
  item: StyledQuestionnaireItem;
  fieldId: string;
  onChange: (event: any) => void;
  value: string;
};

export const DateInput: FC<DateInputProps> = ({ item, fieldId, value, onChange }) => {
  const disabled = item.displayStrategy === 'protected';
  const isMobile = useMediaQuery(`(max-width: 480px)`);

  const inputValue = (() => {
    if (value) {
      return DateTime.fromFormat(value, DOB_DATE_FORMAT);
    } else {
      return null;
    }
  })();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      {isMobile ? (
        <MobileDatePicker
          name={`${fieldId}.answer.0.valueString`}
          value={inputValue}
          disabled={disabled}
          onChange={onChange}
        />
      ) : (
        <DatePicker
          name={`${fieldId}.answer.0.valueString`}
          value={inputValue}
          disabled={disabled}
          onChange={onChange}
        />
      )}
    </LocalizationProvider>
  );
};
